// extracted by mini-css-extract-plugin
module.exports = {"number":"number__2LwGG","inputLabel":"inputLabel__3iZEX","empty":"empty__3aDBl","error":"error__2YkXp"};